import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Grid } from "@mui/material";
import { forwardRef, ReactElement, Ref, useState } from "react";
import { transactionMethods } from "../v2/types/kasse.types";
import { observer } from "mobx-react";
import NewTransactionForm from "./NewTransactionForm";
import { DebitPermissionDto, PatientBillInfoDto } from "../../../../api-client";
import DebitPermission from "../../../pages/PatientBills/components/DebitPermission/DebitPermission";
import { useGetRxDebitByRxId } from "../../../../stores/Transactions/transaction.queries";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface NewAlertDialogSlideProps {
  open: boolean;
  handleClose: () => void;
  patientId: number;
  rxId: string;
  debitPermission?: DebitPermissionDto;
  /** Handoff for the new SEPA one-off flow (opened at the parent level). */
  onSelectEinmal?: () => void;
  handleCreatePatientTransaction: (
    bill: PatientBillInfoDto,
    transactionMethod: transactionMethods,
    debitPermission?: DebitPermissionDto,
  ) => Promise<void>;
}

const NewAlertDialogSlide: React.FC<NewAlertDialogSlideProps> = observer(
  ({
    open,
    handleClose,
    patientId,
    rxId,
    debitPermission,
    onSelectEinmal,
    handleCreatePatientTransaction,
  }) => {
    const [openDialog, setOpenDialog] = useState({
      cash: false,
      ec: false,
      lastschrift: false,
      debitPermission: false,
    });

    const { data: selectedRow } = useGetRxDebitByRxId(rxId, patientId);
    // console.log("Selected Row in NewTransactionMethod: ", selectedRow);

    const handleOpenDialog = (type: string) => {
      setOpenDialog({ ...openDialog, [type]: true });
    };

    const handleCloseFormDialog = (type: string) => {
      setOpenDialog({ ...openDialog, [type]: false });
    };

    return (
      <React.Fragment>
        {openDialog.debitPermission ? (
          <NewTransactionForm
            open={true}
            handleTransactionClose={() => {
              handleCloseFormDialog("lastschrift");
              handleClose();
            }}
            patientId={patientId}
            rxId={rxId}
            debitPermission={debitPermission}
            handleCreatePatientTransaction={handleCreatePatientTransaction}
            transactionMethod={transactionMethods.LASTSCHRIFT}
          />
        ) : (
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Zahlungsdienst auswählen"}</DialogTitle>
            <DialogContent sx={{ marginTop: 2 }}>
              <Grid
                container
                spacing={2}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Grid item>
                  {<Button onClick={() => handleOpenDialog("cash")}>Bargeld</Button>}
                  {openDialog.cash && (
                    <NewTransactionForm
                      open={openDialog.cash}
                      handleTransactionClose={() => {
                        handleCloseFormDialog("cash");
                        handleClose();
                      }}
                      patientId={patientId}
                      rxId={rxId}
                      transactionMethod={transactionMethods.CASH}
                      handleCreatePatientTransaction={handleCreatePatientTransaction}
                    />
                  )}
                </Grid>
                <Grid item>
                  {<Button onClick={() => handleOpenDialog("ec")}>EC Cash</Button>}
                  {openDialog.ec && (
                    <NewTransactionForm
                      open={openDialog.ec}
                      handleTransactionClose={() => {
                        handleCloseFormDialog("ec");
                        handleClose();
                      }}
                      patientId={patientId}
                      rxId={rxId}
                      transactionMethod={transactionMethods.EC}
                      handleCreatePatientTransaction={handleCreatePatientTransaction}
                    />
                  )}
                </Grid>

                <Grid item>
                  {/* LEGACY single-use DebitPermission — replaced by the new SEPA
                      Einmal-Lastschrift flow, which opens at the parent level.
                  <Button onClick={() => handleOpenDialog("lastschrift")}>
                    Einmal Lastschrift
                  </Button>
                  {openDialog.lastschrift && (
                    <DebitPermission
                      open={openDialog.lastschrift}
                      handleTransactionClose={() => {
                        handleCloseFormDialog("lastschrift");
                        handleClose();
                      }}
                      patientData={selectedRow.patient}
                      transactionMethod={transactionMethods.LASTSCHRIFT}
                      selectedRow={selectedRow}
                      isSingleUse={true}
                      isEditing={false}
                    />
                  )} */}
                  <Button
                    onClick={() => {
                      onSelectEinmal?.();
                    }}
                  >
                    Einmal Lastschrift
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Abbrechen</Button>
            </DialogActions>
          </Dialog>
        )}
      </React.Fragment>
    );
  },
);

export default NewAlertDialogSlide;
